/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PersonPaymentAccount/view.blocks to change it.
import Payor from './Payor/index'
import React from 'react'
import Relationship from './Relationship/index'



/** @type {import('Simple/types.js').View} */
export default function PersonPaymentAccount({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount"
  
}) {
  return (<React.Fragment
>
<Relationship
  viewPath={`${viewPath}/Relationship`}
/>
<Payor
  viewPath={`${viewPath}/Payor`}
/>
{children}
</React.Fragment>)
}